<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <img
    src="https://pbs.twimg.com/profile_images/1273669688027942912/cK_GQVwe_400x400.jpg"
    alt=""
  />
  <a class="navbar-brand" href="/dashboard">OpenSpace</a>
  <button
    class="navbar-toggler mr-auto"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="isLoggedIn">
        <a class="nav-link" routerLink="/openspace" routerLinkActive="active"
          >Open's</a
        >
      </li>
      <li class="nav-item" *ngIf="isLoggedIn">
        <a class="nav-link" routerLink="/dashboard" routerLinkActive="active"
          >Panel principal</a
        >
      </li>
      <li class="nav-item" *ngIf="isLoggedIn">
        <a href="/agenda" class="nav-link" routerLink="agenda">Agenda</a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          *ngIf="isAdmin"
          data-toggle="dropdown"
          href="#"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          >Informes</a
        >
        <div class="dropdown-menu navbar-dark bg-dark" style="min-width: 7em">
          <a href="/reports" class="nav-link link" routerLink="reports"
            >Estado</a
          >
          <a href="/survey" class="nav-link link" routerLink="survey"
            >Encuesta</a
          >
        </div>
      </li>
    </ul>
  </div>
  <ul class="navbar-nav p-auto" *ngIf="isLoggedIn">
    <div class="inline">
      <span class="nav-link">
        <app-remaining-votes></app-remaining-votes>
      </span>
    </div>
    <div class="inline">
      <span class="nav-link" style="outline: none">
        <app-open-selector></app-open-selector>
      </span>
    </div>
    <div class="inline">
      <span class="nav-link userMenu" style="outline: none">
        <app-user-menu style="outline: none"></app-user-menu>
      </span>
    </div>
  </ul>
</nav>
